import React, { createContext, useContext, useState, useEffect, useMemo } from "react";
import axios from "axios";
import { getToken } from "../utils/tokenUtils";

const MastersContext = createContext();

export const MastersProvider = ({ children }) => {
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [roles, setRoles] = useState([]);
  const [jobRoles, setJobRoles] = useState([]);
  const [skills, setSkills] = useState([]);
  const [employmentTypes, setEmploymentTypes] = useState([]);
  const [workplaces, setWorkplaces] = useState([]);
  const [forms, setForms] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const [interviewers, setInterviewers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const API_URL = "https://hrmspayroll.prepstripe.com/api/masters"; // Replace with your actual API URL
  const token = getToken();

  // Fetch all master data from API
  const fetchMastersData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(API_URL, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      });
      const data = response.data?.data || {};

      // Set dropdown data
      setDepartments(data.departments || []);
      setDesignations(data.designations || []);
      setShifts(data.shifts || []);
      setRoles(data.roles || []);
      setJobRoles(data.job_roles || []);
      setSkills(data.skills || []);
      setEmploymentTypes(data.employmentType || []);
      setWorkplaces(data.workplace || []);
      setForms(data.forms || []);
      setCandidates(data.candidate || []);
      setInterviewers(data.interviewer || []);
      setError(null);
    } catch (err) {
      console.error("Error fetching masters data:", err.message);
      setError("Failed to load master data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMastersData(); // Load master data at startup
  }, []);

  // Memoize the context value
  const value = useMemo(
    () => ({
      departments,
      designations,
      shifts,
      roles,
      jobRoles,
      skills,
      forms,
      employmentTypes,
      workplaces,
      candidates,
      interviewers,
      loading,
      error,
    }),
    [
      departments,
      designations,
      shifts,
      roles,
      jobRoles,
      skills,
      forms,
      employmentTypes,
      workplaces,
      interviewers,
      candidates,
      loading,
      error,
    ],
  );

  return <MastersContext.Provider value={value}>{children}</MastersContext.Provider>;
};

// Custom hook to access the MastersContext
export const useMasters = () => useContext(MastersContext);
